(function () {
  // ── Intelligems custom events ──
  function pushIgEvent(payload) {
    window.igEvents = window.igEvents || [];
    window.igEvents.push(payload);
  }

  function refreshCartDrawer() {
    fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.drawer__inner');
          var current = document.querySelector('.drawer__inner');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        } catch (e) {}
      })
      .catch(function () {});
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var el = document.querySelector('.cart-count-bubble span');
        if (el) el.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  // ── Quick-view modal open ──
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-c-cross-sell-opener]');
    if (!opener || opener.disabled) return;

    pushIgEvent({ event: 'crosssell_product_click' });

    var tplId = opener.getAttribute('data-modal-tpl');
    var tpl = tplId ? document.getElementById(tplId) : null;
    var modal = document.querySelector('[data-c-pdp-modal]');
    var mount = modal ? modal.querySelector('[data-c-pdp-modal-mount]') : null;
    if (!tpl || !modal || !mount) return;

    mount.innerHTML = '';
    mount.appendChild(tpl.content.cloneNode(true));
    modal.hidden = false;
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    document.body.classList.add('overflow-hidden');
  });

  function closeModal() {
    var modal = document.querySelector('[data-c-pdp-modal]');
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    setTimeout(function () {
      modal.hidden = true;
      var mount = modal.querySelector('[data-c-pdp-modal-mount]');
      if (mount) mount.innerHTML = '';
    }, 200);
  }

  // Capture phase, so no other script's bubble-phase click handler
  // (e.g. a theme script closing its own dropdown/search overlay) can
  // swallow this with stopPropagation() before it reaches us.
  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest('[data-c-pdp-modal-close]')) closeModal();
    },
    true
  );

  // iOS Safari doesn't always synthesize a `click` from a tap on a plain
  // <div> reliably — handle the tap directly so close-on-outside-click
  // works the same on touch as it does with a mouse.
  document.addEventListener(
    'touchend',
    function (e) {
      var closeTarget = e.target.closest('[data-c-pdp-modal-close]');
      if (!closeTarget) return;
      e.preventDefault();
      closeModal();
    },
    { capture: true, passive: false }
  );

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  // Belt-and-suspenders: bind directly to every close target too, in case
  // something upstream is interfering with delegated document listeners.
  // The modal shell renders once, outside the cart drawer's refresh cycle,
  // so these elements never get replaced.
  document.querySelectorAll('[data-c-pdp-modal-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      closeModal();
    });
    el.addEventListener(
      'touchend',
      function (e) {
        e.preventDefault();
        closeModal();
      },
      { passive: false }
    );
  });

  // ── Rating link: stay on the same tab, close the drawer/modal first ──
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-c-pdp-reviews-link]');
    if (!link) return;
    e.preventDefault();

    var href = link.getAttribute('href');
    var targetPath = (link.getAttribute('data-product-url') || '').split('#')[0];
    var hash = href.indexOf('#') > -1 ? href.split('#')[1] : '';

    closeModal();
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl && typeof cartDrawerEl.close === 'function') cartDrawerEl.close();

    if (targetPath && targetPath === window.location.pathname) {
      var reviewsEl = hash ? document.getElementById(hash) : null;
      if (reviewsEl) reviewsEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = href;
    }
  });

  // ── Variant option selection inside the modal ──
  function getVariants(mount) {
    var script = mount.querySelector('[data-c-pdp-variants]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  }

  function findMatchingVariant(variants, selectedValues) {
    return variants.find(function (v) {
      return selectedValues.every(function (val, i) {
        return val == null || v.options[i] === val;
      });
    });
  }

  function updateModalForVariant(mount, variant) {
    var addBtn = mount.querySelector('[data-c-pdp-add]');
    var priceWrap = mount.querySelector('[data-c-pdp-price]');
    var priceWas = mount.querySelector('[data-c-pdp-price-was]');
    var priceNow = mount.querySelector('[data-c-pdp-price-now]');
    var discount = mount.querySelector('[data-c-pdp-discount]');
    var image = mount.querySelector('[data-c-pdp-image]');

    if (!variant) {
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
        addBtn.removeAttribute('data-variant-id');
      }
      return;
    }

    if (priceNow) priceNow.textContent = variant.price;
    if (priceWas) {
      if (variant.compare_at_price) {
        priceWas.textContent = variant.compare_at_price;
        priceWas.style.display = '';
      } else {
        priceWas.style.display = 'none';
      }
    }
    if (discount) discount.style.display = variant.compare_at_price ? '' : 'none';
    if (image && variant.image) image.src = variant.image;

    if (addBtn) {
      addBtn.setAttribute('data-variant-id', variant.id);
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Add To Cart' : 'Sold Out';
    }
  }

  document.addEventListener('click', function (e) {
    var valueBtn = e.target.closest('[data-c-pdp-option-value]');
    if (!valueBtn) return;

    var optionRow = valueBtn.closest('[data-c-pdp-option]');
    var mount = valueBtn.closest('[data-c-pdp-modal-mount]');
    if (!optionRow || !mount) return;

    optionRow.querySelectorAll('[data-c-pdp-option-value]').forEach(function (btn) {
      btn.classList.remove('is-selected');
    });
    valueBtn.classList.add('is-selected');

    var selectedLabel = optionRow.querySelector('[data-c-pdp-selected-value]');
    if (selectedLabel) selectedLabel.textContent = valueBtn.getAttribute('data-value');

    var optionRows = Array.from(mount.querySelectorAll('[data-c-pdp-option]')).sort(function (a, b) {
      return Number(a.getAttribute('data-option-index')) - Number(b.getAttribute('data-option-index'));
    });
    var selectedValues = optionRows.map(function (row) {
      var selected = row.querySelector('.is-selected[data-c-pdp-option-value]');
      return selected ? selected.getAttribute('data-value') : null;
    });

    var variants = getVariants(mount);
    var match = findMatchingVariant(variants, selectedValues);
    updateModalForVariant(mount, match);
  });

  // ── Add to cart from the modal ──
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-c-pdp-add]');
    if (!btn || btn.disabled) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('failed');
        return res.json();
      })
      .then(function () {
        updateCartCount();
        refreshCartDrawer();
        closeModal();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = originalText;
      });
  });

  // ── free_shipping_unlocked_view: fires once per unlock, the moment the
  // celebration bar actually becomes visible (IntersectionObserver naturally
  // handles the drawer being closed off-screen via transform) ──
  var freeShipUnlockedViewed = false;
  var freeShipObserver = null;

  function watchFreeShipUnlockedView() {
    var bar = document.querySelector('.c-cart-free-ship-bar');

    if (!bar || !bar.classList.contains('c-cart-free-ship-bar--met')) {
      freeShipUnlockedViewed = false;
      if (freeShipObserver) {
        freeShipObserver.disconnect();
        freeShipObserver = null;
      }
      return;
    }

    if (freeShipUnlockedViewed) return;
    if (typeof IntersectionObserver === 'undefined') return;

    if (freeShipObserver) freeShipObserver.disconnect();

    freeShipObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !freeShipUnlockedViewed) {
            freeShipUnlockedViewed = true;
            pushIgEvent({ event: 'free_shipping_unlocked_view' });
            if (freeShipObserver) freeShipObserver.disconnect();
          }
        });
      },
      { threshold: 0.5 }
    );
    freeShipObserver.observe(bar);
  }

  document.addEventListener('DOMContentLoaded', watchFreeShipUnlockedView);

  var freeShipMutationTarget = null;
  function watchDrawerForFreeShipChanges() {
    var inner = document.querySelector('.drawer__inner');
    if (!inner || inner === freeShipMutationTarget) return;
    freeShipMutationTarget = inner;
    new MutationObserver(watchFreeShipUnlockedView).observe(inner, { childList: true });
  }

  document.addEventListener('DOMContentLoaded', watchDrawerForFreeShipChanges);
})();
